export default "__VITE_ASSET__c6f00b18__"